
import { Context } from '@nuxt/types'
import MachinationsLightPage from '~/domain/pages/MachinationsLightPage'
import AcquisitionFAQ from '~/components/acquisition/AcquisitionFAQ.vue'
import BlogSinglePost from '~/components/blog/single-post/BlogSinglePost.vue'
import CommonTextBlock from '~/components/common/CommonTextBlock.vue'

export default MachinationsLightPage.extend({
  name: 'BlogPostPage',
  components: { CommonTextBlock, BlogSinglePost, AcquisitionFAQ },
  layout: 'machinations',
  head() {
    // @ts-ignore
    const pageHead = this.pageHead()
    const wpPost = this.wpPost as any
    const postURL = this.postUrl as any
    let pageSchema = [] as any

    // Add Articles schema if post exist
    if (wpPost) {
      pageSchema.push({
        '@context': 'https://schema.org',
        '@type': 'Article',
        '@id': postURL,
        url: postURL,
        name: pageHead.title,
        headline: pageHead.title,
        about: {
          '@type': 'Thing',
          name: wpPost.categoryData.name,
        },
        publisher: {
          '@type': 'Organization',
          '@id': this.$config.nuxtBaseURL,
          name: 'Machinations',
        },

        isPartOf: {
          '@type': 'CollectionPage',
          name: wpPost.categoryData.name,
          url: `${this.$config.nuxtBaseURL}/articles/category/${wpPost.categoryData.slug}`,
        },
        author: {
          '@type': 'Person',
          name: wpPost.authorDetails.name,
          url: `${this.$config.nuxtBaseURL}/articles/author/${wpPost.authorDetails.slug}`,
          description: wpPost.authorDetails.description,
          image: wpPost.authorDetails.acf.image.url,
        },
        datePublished: wpPost.date_gmt,
        dateModified: wpPost.modified_gmt,

        inLanguage: 'en-US',
        description: wpPost.yoast_head_json.og_description,
        potentialAction: {
          '@type': 'ReadAction',
          target: postURL,
        },
        thumbnailUrl: wpPost.thumbnail,
      })
    }

    // Add FAQPage schema if FAQ blocks exist
    const FAQSectionTitle = this.wpPost?.acf?.blocks?.[1]?.block.title
    const FAQBlocks = this.wpPost?.acf?.blocks?.[1]?.block.faq

    if (FAQSectionTitle && FAQBlocks) {
      const FAQMainEntity = [] as any

      FAQBlocks.forEach((faq) => {
        FAQMainEntity.push({
          '@type': 'Question',
          name: faq.title,
          acceptedAnswer: {
            '@type': 'Answer',
            text: faq.extra_content,
          },
        })
      })

      const FAQSchema = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: FAQMainEntity,
      }

      pageSchema.push(FAQSchema)
    }

    return {
      ...pageHead,
      link: [
        {
          hid: 'canonical',
          rel: 'canonical',
          //@ts-ignore
          href: this.wpPost?.acf?.custom_article_canonical
            ? //@ts-ignore
              this.wpPost?.acf?.custom_article_canonical
            : this.$config.nuxtBaseURL + this.$route.path,
        },
        ...pageHead?.meta,
      ],
      script: [
        {
          type: 'application/ld+json',
          json: pageSchema,
        },
      ],
    }
  },

  computed: {
    wpPost() {
      // @ts-ignore
      return this.$store.state.wp.selectedPost
    },
    postUrl() {
      return `${this.$config.nuxtBaseURL}/articles/${this.$store.state.wp.selectedPost.slug}`
    },
  },

  methods: {
    toCamelCase(str) {
      return str.replace(/[-_](\w)/g, (_, c) => c.toUpperCase())
    },

    convertKeysToCamelCase(faqBlock) {
      if (!faqBlock || typeof faqBlock !== 'object') {
        return faqBlock
      }
      return Array.isArray(faqBlock)
        ? faqBlock.map(this.convertKeysToCamelCase)
        : Object.entries(faqBlock).reduce(
            (faqBlockCamelCased, [key, value]) => {
              faqBlockCamelCased[this.toCamelCase(key)] =
                this.convertKeysToCamelCase(value)
              return faqBlockCamelCased
            },
            {}
          )
    },
  },

  async asyncData(context: Context): Promise<any> {
    const { store, params, error, route } = context

    await store.dispatch('common/setupPageLight', { context })
    await store.dispatch('wp/resetSelectedCategory')

    try {
      await store.dispatch('wp/preparePostDetails', {
        context,
        slugPost: params.slugPost,
      })
    } catch (err) {
      console.log('slugPost err:', err)
      return error({
        statusCode: 404,
        message: `Invalid route: ${route.path}`,
      })
    }
  },
})
